import { capitalize } from 'vue';

import LineItemStatus from '@/common/models/lineitem/LineItemStatus.enum';
import Filter from '@/common/models/query-params/Filter';
import * as FilterComparisonOperator from '@/common/models/query-params/FilterComparisonOperator';
import LogicalOperator from '@/common/models/query-params/FilterLogicalOperator.enum';
import i18n from '@/vueI18n';

export interface ICreativeOption {
  value: LineItemStatus;
  name: string;
  logicalOperator: LogicalOperator;
  filters: Filter[];
}

export default class CreativeOptions {
  static getLocalizedOptionName(name: string): string {
    return capitalize(i18n.global.t(`states.${name}`));
  }

  static demandStatusOptions() {
    return CreativeOptions.options();
  }

  static supplyStatusOptions() {
    return CreativeOptions.options();
  }

  static options(): ICreativeOption[] {
    return [
      {
        value: LineItemStatus.APPROVED,
        name: CreativeOptions.getLocalizedOptionName('approved'),
        logicalOperator: LogicalOperator.AND,
        filters: [
          new Filter(
            'mediaowner_approvals.state',
            [LineItemStatus.APPROVED],
            FilterComparisonOperator.NOT_EQUAL,
            LogicalOperator.NOT,
          ),
        ],
      },
      {
        value: LineItemStatus.CANCELLED,
        name: CreativeOptions.getLocalizedOptionName('cancelled'),
        logicalOperator: undefined,
        filters: undefined,
      },
      {
        value: LineItemStatus.DRAFT,
        name: CreativeOptions.getLocalizedOptionName('draft'),
        logicalOperator: undefined,
        filters: undefined,
      },
      {
        value: LineItemStatus.PENDING_APPROVAL,
        name: CreativeOptions.getLocalizedOptionName('pendingApproval'),
        logicalOperator: LogicalOperator.AND,
        filters: [new Filter('mediaowner_approvals.state', [LineItemStatus.PENDING_APPROVAL])],
      },
      {
        value: LineItemStatus.REJECTED,
        name: CreativeOptions.getLocalizedOptionName('rejected'),
        logicalOperator: LogicalOperator.AND,
        filters: [new Filter('mediaowner_approvals.state', [LineItemStatus.REJECTED])],
      },
    ];
  }
}
